import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  Inject,
  Injectable,
  PLATFORM_ID,
  Renderer2,
  RendererFactory2,
} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DynamicMetaService {
  platformId: Object;
  private renderer: Renderer2;

  constructor(
    @Inject(PLATFORM_ID) platFormId: Object,
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.platformId = platFormId;
  }

  loadMeta(meta_info: any) {
    console.log(meta_info);
    if (isPlatformBrowser(this.platformId)) {
      // Client-side logic
      const dom = new DOMParser().parseFromString(meta_info, 'text/html');
      const meta_data_form_parser = dom.head.children;
      let resultDom = [];
      const head = this.document.head;
      for (let meta of Array.from(meta_data_form_parser)) {
        resultDom.push(head.appendChild(meta));
      }
      return resultDom;
    } else if (isPlatformServer(this.platformId)) {
      // Server-side logic
      this.document.head.innerHTML += meta_info;
    }
    return undefined;
  }

  unLoadMeta(meta_data: any) {
    console.log(meta_data);
    if (isPlatformBrowser(this.platformId)) {
      if (!Array.isArray(meta_data) || meta_data.length === 0) {
        return;
      }
      const head = this.document.head;
      if (!head) return;
      for (let meta of meta_data) {
        if (meta && meta.parentNode === head) {
          head.removeChild(meta);
        } else {
          if (!meta) {
            console.warn(
              'Attempted to remove a null or undefined meta tag entry from the list.'
            );
          } else if (meta.parentNode !== head) {
            console.warn(
              'Meta tag was not removed because it is not a direct child of head. It might have been already removed or moved.',
              meta
            );
          }
        }
      }
    }
  }
}
